import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { categories } from './colors'
import DirectoryContext from './state/context'

const LegendList = styled.ul`
  margin: 12px 0;
  padding: 0;
  list-style: none;

  @media screen and (min-width: 960px) {
    margin: 32px 36px;
  }

  li {
    display: flex;
    align-items: center;
    font-family: 'freight-text-pro', serif;
    font-weight: 500;
    font-size: 20px;
    font-size: 1.25rem;
    color: #111;
    margin-bottom: 6px;

    @media screen and (min-width: 500px) {
      font-size: 25px;
      font-size: 1.5625rem;
    }

    &::before {
      display: none;
    }
  }

  span {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    margin-right: 6px;

    @media screen and (min-width: 500px) {
      width: 22px;
      height: 22px;
    }
  }
`

const Legend = React.forwardRef((_, ref) => {
  const context = useContext(DirectoryContext)
  const [items, setItems] = useState([])

  useEffect(() => {
    const loadedCategories = []

    context.assets.forEach((asset) => {
      const category = asset.category

      if (!loadedCategories.find((c) => c.name === category)) {
        loadedCategories.push({
          name: category,
          color: categories[category],
        })
      }
    })

    setItems(loadedCategories)
  }, [context.assets])

  return (
    <LegendList ref={ref}>
      {items.map((item) => (
        <li key={item.name}>
          <span
            style={{
              backgroundColor: item.color,
            }}
          />

          {item.name}
        </li>
      ))}
    </LegendList>
  )
})

export default Legend
